module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_8003.2c327928.png";